import axios from "axios";

// const ServerUrl = "https://callup-server-145a8399d1a7.herokuapp.com/";
// const ServerUrl = "http://localhost:8000/";
const ServerUrl = "https://test-server-callup-eef8bc527d63.herokuapp.com/";

const getGetParameters = (data) => {
  return Object.keys(data)
    .map((key) => `${key}=${data[key]}`)
    .join("&");
};

const getConfig = () => {
  let config = {};
  config.headers = new Headers({
    "Content-Type": "application/json",
  });
  const token = localStorage.getItem("callup");
  if (token) config.headers["Authorization"] = "Bearer " + token;

  return config;
};

export const get = async (relativePath, data = {}) => {
  let url = ServerUrl + relativePath;
  // parse object into parameters string
  const urlParameters = getGetParameters(data);
  if (urlParameters !== "")
    // add parameters, only if there is something to add..
    url = url + "?" + urlParameters;
  let headers = { Authorization: "Bearer " + localStorage["callup"] };
  try {
    const { data, error, status } = await axios.get(url, { headers });
    return { data, error, status };
  } catch (err) {
    return { error: err.response.data, status: err.response.status };
  }
};

export const post = async (relativePath, body = {}) => {
  let url = ServerUrl + relativePath;
  try {
    let headers = { Authorization: "Bearer " + localStorage["callup"] };
    const { data, error, status } = await axios.post(url, body, { headers });
    return { data, error, status };
  } catch (err) {
    return { error: err.response.data, status: err.response.status };
  }
};

export const uploadImage = async (relativePath, body = {}) => {
  let url = ServerUrl + relativePath;
  // let config = getConfig();
  // config["Content-Type"] = "multipart/form-data";

  let headers = {
    Authorization: "Bearer " + localStorage["callup"],
    "Content-Type": "multipart/form-data",
  };
  try {
    const { data, error, status } = await axios.post(url, body, { headers });
    return { data, error, status };
  } catch (err) {
    return { error: err.response.data, status: err.response.status };
  }
};

export const uploadImage1 = async (relativePath, data = {}) => {
  let url = ServerUrl + relativePath;
  let config = getConfig();
  config["Content-Type"] = "multipart/form-data";
  return axios.post(url, data, config).then(
    (data) => {
      if (data.status !== 200) throw data.data;
      return data.data;
    },
    (serverException) => {
      throw serverException.response.data;
    },
  );
};
